var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { SkinBase } from '../mvc/SkinBase';
import { RES } from '../net/Res';
import { FairyLoader } from '../supports/FairyLoader';
import { FairyRes } from '../supports/FairyRes';
import { ReadyExecute } from '../utils/ReadyExecute';
/**
 * 特效异步播放
 * 暂时只支持特效独立资源格式（fgui编辑器中设置）
 */
export class GMovieClicp extends SkinBase {
    constructor() {
        super(new FairyLoader());
    }
    doReady() {
        this._icon = this._skin.asLoader;
        this._icon.align = 'center';
        this._icon.verticalAlign = 'middle';
        this._resReady = new ReadyExecute();
    }
    setURL(resName, itemName) {
        return __awaiter(this, void 0, void 0, function* () {
            this._resReady.isReady = false;
            const pkg = yield FairyRes.loadPackage(resName);
            if (!pkg)
                return;
            const item = pkg.getItemByName(itemName);
            if (!item)
                return;
            const resURI = `res/ui/${pkg.name}_atlas_${item.id}.png`;
            RES.load(resURI).then(() => {
                this._icon.url = fgui.UIPackage.getItemURL(pkg.name, itemName);
                this._resReady.isReady = true;
            });
        });
    }
    setPlay(times, endHandler) {
        if (!this._resReady.isReady) {
            this._resReady.add2(this.setPlay, this, [times, endHandler]);
            return;
        }
        this._icon.content.setPlaySettings(0, -1, times, -1, endHandler);
    }
    dispose() {
        this._icon.dispose();
    }
}
